// extracted by mini-css-extract-plugin
module.exports = {"root":"medical-info-page_root___ASp7"};